import React from 'react';
import './css/Footer.css';
import logo_mat from './images/logo_mat.png';
import logo_rp from './images/footer/Barwy_RP.png';
import logo_fundusze from './images/footer/Logo_FE_RGB_Fundusze_Europejskie_RGB-1.png';
import logo_ncbir_croop from './images/footer/NCBIR.png';
import logo_ue from './images/footer/ue-efrr.png';

const Footer = ({ isCollapsed }) => {

    return (
        <footer className="footer">
            <div className="footer-left">
                <p>Projekt dofinansowany z  konkursu „Szybka Ścieżka” realizowany w ramach Poddziałania 1.1.1. „Badania przemysłowe i prace rozwojowe realizowane przez przedsiębiorstwa” Programu Operacyjnego Inteligentny Rozwój 2014-2020 przez Narodowe Centrum Badań i Rozwoju.</p>
            </div>

            <div className="footer-right">
                <img className="logo-ncbir logo-nav-footer" src={logo_ncbir_croop} alt="NCBiR" />
                <img className="logo-nav-footer" src={logo_fundusze} alt="Fundusze Europejskie" />
                <img className="logo-pl logo-nav-footer" src={logo_rp} alt="Rzeczpospolita Polska" />
                <img className="logo-ue logo-nav-footer" src={logo_ue} alt="Unia Europejska - europejski fundusz rozwoju regionalnego" />
            </div>
        </footer>
    );
};

export default Footer;